import { render, staticRenderFns } from "./AssignRatePlan.vue?vue&type=template&id=3bf4686b&scoped=true&"
import script from "./AssignRatePlan.vue?vue&type=script&lang=js&"
export * from "./AssignRatePlan.vue?vue&type=script&lang=js&"
import style0 from "./AssignRatePlan.vue?vue&type=style&index=0&id=3bf4686b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4686b",
  null
  
)

export default component.exports